<template>
    <div>
        <div v-if="loading">
            <loading></loading>
        </div>

        <div v-else>
            <b-alert variant="danger" :show="hasErrors">
                <span v-html="errorMessage"></span>
            </b-alert>
            <b-table
                responsive
                small
                :items="filteredItems"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="['search']"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                primary-key="client_id"
                @filtered="onFiltered"
            >
                <template #cell(jan)="data">
                    <span class="number-font">
                        {{ formatNumber(data.item.jan) }}
                    </span>
                </template>
                <template #cell(feb)="data">
                    <span class="number-font">
                        {{ formatNumber(data.item.feb) }}
                    </span>
                </template>
                <template #cell(mar)="data">
                    <span class="number-font">
                        {{ formatNumber(data.item.mar) }}
                    </span>
                </template>
                <template #cell(apr)="data">
                    <span class="number-font">
                        {{ formatNumber(data.item.apr) }}
                    </span>
                </template>
                <template #cell(may)="data">
                    <span class="number-font">
                        {{ formatNumber(data.item.may) }}
                    </span>
                </template>
                <template #cell(jun)="data">
                    <span class="number-font">
                        {{ formatNumber(data.item.jun) }}
                    </span>
                </template>
                <template #cell(jul)="data">
                    <span class="number-font">
                        {{ formatNumber(data.item.jul) }}
                    </span>
                </template>
                <template #cell(aug)="data">
                    <span class="number-font">
                        {{ formatNumber(data.item.aug) }}
                    </span>
                </template>
                <template #cell(sep)="data">
                    <span class="number-font">
                        {{ formatNumber(data.item.sep) }}
                    </span>
                </template>
                <template #cell(oct)="data">
                    <span class="number-font">
                        {{ formatNumber(data.item.oct) }}
                    </span>
                </template>
                <template #cell(nov)="data">
                    <span class="number-font">
                        {{ formatNumber(data.item.nov) }}
                    </span>
                </template>
                <template #cell(dec)="data">
                    <span class="number-font">
                        {{ formatNumber(data.item.dec) }}
                    </span>
                </template>
                <template #cell(year)="data">
                    <span class="number-font">
                        {{ formatNumber(data.item.year) }}
                    </span>
                </template>
                <!-- FOOT -->
                <template #custom-foot="data">
                    <b-tr class="bg-light">
                        <b-th>TOTAL</b-th>
                        <b-th class="text-right number-font">
                            {{ formatNumber(total.jan) }}
                        </b-th>
                        <b-th class="text-right number-font">
                            {{ formatNumber(total.feb) }}
                        </b-th>
                        <b-th class="text-right number-font">
                            {{ formatNumber(total.mar) }}
                        </b-th>
                        <b-th class="text-right number-font">
                            {{ formatNumber(total.apr) }}
                        </b-th>
                        <b-th class="text-right number-font">
                            {{ formatNumber(total.may) }}
                        </b-th>
                        <b-th class="text-right number-font">
                            {{ formatNumber(total.jun) }}
                        </b-th>
                        <b-th class="text-right number-font">
                            {{ formatNumber(total.jul) }}
                        </b-th>
                        <b-th class="text-right number-font">
                            {{ formatNumber(total.aug) }}
                        </b-th>
                        <b-th class="text-right number-font">
                            {{ formatNumber(total.sep) }}
                        </b-th>
                        <b-th class="text-right number-font">
                            {{ formatNumber(total.oct) }}
                        </b-th>
                        <b-th class="text-right number-font">
                            {{ formatNumber(total.nov) }}
                        </b-th>
                        <b-th class="text-right number-font">
                            {{ formatNumber(total.dec) }}
                        </b-th>
                        <b-th class="text-right number-font">
                            {{ formatNumber(total.year) }}
                        </b-th>
                    </b-tr>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import loading from '../../../common/components/loading'
import TableHandler from '../../../common/mixins/TableHandler'
import DashboardHandler from '../../../dashboard/mixins/DashboardHandler'

export default {
    name: 'TableFees',

    components: {
        loading,
    },

    mixins: [TableHandler, DashboardHandler],

    props: {
        client: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            budgetType: 'all',
            accountingFirmCompanyId: 0,
            fields: [
                { key: 'title', label: 'Activité', sortable: true },
                {
                    key: 'jan',
                    label: 'jan',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'feb',
                    label: 'fév',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'mar',
                    label: 'mar',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'apr',
                    label: 'avr',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'may',
                    label: 'mai',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'jun',
                    label: 'jun',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'jul',
                    label: 'jul',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'aug',
                    label: 'aoû',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'sep',
                    label: 'sep',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'oct',
                    label: 'oct',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'nov',
                    label: 'nov',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'dec',
                    label: 'déc',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
                {
                    key: 'year',
                    label: 'TOTAL',
                    class: 'text-right td-dashboard-data-sm',
                    sortable: true,
                },
            ],
            total: {},
        }
    },

    async created() {
        await this.getData()
    },

    methods: {
        async getData() {
            this.loading = true
            try {
                const response = await axios.get(
                    `/dashboard/fees/by-activity/${this.year}/client/${this.client}`
                )
                this.items = response.data.data
                this.calculateTotal()
                this.loading = false
            } catch (error) {
                console.log(error)
                this.handleErrors(error.response)
            }
        },

        initTotal() {
            this.total.jan = 0
            this.total.feb = 0
            this.total.mar = 0
            this.total.apr = 0
            this.total.may = 0
            this.total.jun = 0
            this.total.jul = 0
            this.total.aug = 0
            this.total.sep = 0
            this.total.oct = 0
            this.total.nov = 0
            this.total.dec = 0
            this.total.year = 0
        },

        calculateTotal() {
            this.initTotal()

            this.items.forEach((item) => (this.total.jan += item.jan))
            this.items.forEach((item) => (this.total.feb += item.feb))
            this.items.forEach((item) => (this.total.mar += item.mar))
            this.items.forEach((item) => (this.total.apr += item.apr))
            this.items.forEach((item) => (this.total.may += item.may))
            this.items.forEach((item) => (this.total.jun += item.jun))
            this.items.forEach((item) => (this.total.jul += item.jul))
            this.items.forEach((item) => (this.total.aug += item.aug))
            this.items.forEach((item) => (this.total.sep += item.sep))
            this.items.forEach((item) => (this.total.oct += item.oct))
            this.items.forEach((item) => (this.total.nov += item.nov))
            this.items.forEach((item) => (this.total.dec += item.dec))
            this.items.forEach((item) => (this.total.year += item.year))
        },

        formatNumber(number) {
            if (number === 0) {
                return '-'
            }
            if (number === null) {
                return '-'
            }
            return Math.floor(number).toLocaleString()
        },
    },

    computed: {
        ...mapState({
            year: (state) => state.browsing.year,
        }),
    },
}
</script>

<style scoped></style>
